import { Directive, HostListener } from '@angular/core';
import { BaseDirective } from './base.directive';

@Directive({
  selector: '[appNoLeftZero]',
  standalone: true
})
export class NoLeftZeroDirective extends BaseDirective {

  constructor() { super(); }

  @HostListener('input', ['$event'])
  onInput(event: KeyboardEvent) {
    if (this.teclaPermitidaPresionada(event)) return;
    this.filterInput(event);
  }

  filterInput(event: KeyboardEvent) {
    if ((event.target as HTMLInputElement).value === '0') {
      return;
    }

    if ((event.target as HTMLInputElement).value.startsWith('0')) {
      (event.target as HTMLInputElement).value = (event.target as HTMLInputElement).value.replace(/^0+/, '');
    }
  }
}
